import { AsYouType } from 'libphonenumber-js';
export default phoneNr => {
  if (phoneNr === undefined || phoneNr.length === 0) return true;
  const ayt = new AsYouType();
  ayt.input(phoneNr);
  return phoneNr === `+${ayt.getCallingCode()}`;
};